import '@/scss/pages/shop/shop.scss';
import {newProductsSwiper} from "@/js/pages/home/components/newProductsSwiper";
import {stockSwiper} from "@/js/pages/home/components/stockSwiper";


stockSwiper();
newProductsSwiper();
